@if (isDownloadable()) {
  <pas-button-round
    [color]="pasButtonRoundColor.DARK"
    (click)="onDownload($event)"
    icon="cloud_download"
    size="small"></pas-button-round>
}
&nbsp;
@if (isDeletable()) {
  <pas-button-round
    [color]="pasButtonRoundColor.DARK"
    (click)="onDelete($event)"
    icon="delete"
    size="small"></pas-button-round>
}
